import React, { Component } from "react";
import {
  Breadcrumb,
  Container,
  Header,
  Grid,
  Menu,
  Segment,
  Statistic,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import update from "immutability-helper";
import { translate } from "react-i18next";
import SimpleList from "../lists/SimpleList";
import moment from "moment";
import numeral from "numeral";

const INITIAL_STATE = {
  saldo: {
    loading: false,
    data: 0,
    error: null,
  },
};

class BalanceView extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;

    this.TransactionService = props.services.feathers.service(
      "api/transactions"
    );
    this.SaldoService = props.services.feathers.service("api/saldo");
  }

  getSaldo = () => {
    let { authentication } = this.props;

    this.setState(
      update(this.state, {
        saldo: {
          $merge: {
            loading: true,
            data: "Cargando...",
          },
        },
      })
    );

    this.SaldoService.get(authentication.user.SocioId)
      .then((response) => {
        console.log(response);
        this.setState(
          update(this.state, {
            saldo: {
              $merge: {
                loading: false,
                data: numeral(response.monto).format("$0,0.00"),
              },
            },
          })
        );
      })
      .catch((error) => {
        this.setState(
          update(this.state, {
            saldo: {
              $merge: {
                loading: false,
                error,
              },
            },
          })
        );
      });
  };

  componentDidMount() {
    this.getSaldo();
  }

  static mapDispatchToProps(dispatch) {
    return {
      dispatch,
      navigate: (path) => dispatch(push(path)),
    };
  }

  static mapStateToProps(state) {
    return {
      authentication: state.authentication.toJS(),
    };
  }

  render() {
    const { t, authentication } = this.props;
    const { saldo } = this.state;

    return (
      <Container>
        <Menu
          inverted
          style={{ backgroundColor: "#136444", borderRadius: 0, margin: 0 }}
        >
          <Menu.Item as={Link} name="inicio" active={false} to="/dashboard" />
          <Menu.Item
            as={Link}
            name="mis reservas"
            active={false}
            to="/reservations"
          />
          <Menu.Item name="mi saldo" active={true} />
        </Menu>

        <Segment vertical secondary style={{ padding: 4 }}>
          <Breadcrumb>
            <Breadcrumb.Section as={Link} link to={"/dashboard"}>
              Inicio
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section active>Balance</Breadcrumb.Section>
          </Breadcrumb>
        </Segment>

        <Segment vertical>
          <Header as="h3">
            <Header.Content>
              MI SALDO
              <Header.Subheader>Transacciones de balance</Header.Subheader>
            </Header.Content>
          </Header>
        </Segment>

        <Segment vertical>
          <Grid columns={2} stackable reversed="mobile">
            <Grid.Column>
              <SimpleList
                header="Mis Saldo"
                subheader="Transacciones"
                service={this.TransactionService}
                findParams={{
                  query: { $limit: 20, SocioId: authentication.user.SocioId },
                }}
                mappingFunc={(transaction) => ({
                  header: transaction.concepto,
                  description: moment(transaction.fecha)
                    .parseZone()
                    .format("DD/MM/YYYY HH:mm"),
                  icon: transaction.monto > 0 ? "circle add" : "circle minus",
                  iconColor: transaction.monto > 0 ? "green" : "red",
                  floatedContent: numeral(transaction.monto).format("$0,0.00"),
                  floatedContentColor: transaction.monto > 0 ? "green" : "red",
                })}
                headerButton={{
                  content: "Cargar saldo",
                  icon: "add",
                  to: "/balance/addfunds",
                }}
                statisticValue={`${saldo.data}`}
                statisticLabel="Balance"
                expandLink="/balance"
              />
              Si realizó una carga, tenga en cuenta que puede tardar hasta 72hs
              en acreditarse. Caso contrario comuniquese con el club.
            </Grid.Column>
            <Grid.Column>
              <Grid>
                <Grid.Column textAlign="center">
                  <Segment circular color="blue" textAlign="center">
                    <Statistic
                      label="Total"
                      size="small"
                      value={`${saldo.data}`}
                    />
                  </Segment>
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>
        </Segment>
      </Container>
    );
  }
}

const i18nEnhancement = translate("translations")(BalanceView);

export default connect(
  BalanceView.mapStateToProps,
  BalanceView.mapDispatchToProps
)(i18nEnhancement);



// WEBPACK FOOTER //
// ./src/components/views/BalanceView.jsx